var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full media",staticStyle:{"z-index":"0"}},_vm._l((_vm.bgm),function(item){return _c('audio',{key:item.name,ref:item.name,refInFor:true,attrs:{"src":item.src,"preload":"","loop":"loop"}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }